import {SET_AGREEMENTS_LIST} from '../mutation-types';
import {getAgreements} from '@/api/agreement-api';
import {feeAgreementsTypes} from "@/constants/agreement-constants";

const initialState = {
    list: []
};

const getters = {
    activeAgreements: state => {
        return state.list.filter(agreement => {
            let today = new Date();
            return today < agreement.endDate && today > agreement.startDate
        });
    },
    feeAgreements: (state, getters) => {
        return getters.activeAgreements.filter(agreement => feeAgreementsTypes.includes(agreement.type));
    },
    feeAgreementsByHeadquarters: (state, getters) => (headquartersId) => {
        return getters.feeAgreements.filter(agreement => (agreement.headquarters.find(headquarters => (headquarters.uuid === headquartersId))));
    },
    commonAgreements: (state, getters) => {
        return getters.activeAgreements.filter(agreement => !feeAgreementsTypes.includes(agreement.type));
    },
    commonAgreementsByHeadquarters: (state, getters) => (headquartersId) => {
        return getters.activeAgreements.filter(agreement => (agreement.headquarters.find(headquarters => (headquarters.uuid === headquartersId))));
    }
};

const mutations = {
    [SET_AGREEMENTS_LIST](state, agreements) {
        state.list = agreements;
    }
};

const actions = {
    loadAgreements({commit}) {
        return new Promise((resolve, reject) => {
            getAgreements()
                .then(agreements => {
                    commit(SET_AGREEMENTS_LIST, agreements);
                    resolve(true);
                })
                .catch(() => {
                    reject(false);
                });
        });
    }
};

export default {
    state: initialState,
    getters,
    mutations,
    actions
}
